import { render } from "./Wrapper.vue?vue&type=template&id=2038ebaf"
import script from "./Wrapper.vue?vue&type=script&lang=js"
export * from "./Wrapper.vue?vue&type=script&lang=js"

import "./Wrapper.vue?vue&type=style&index=0&id=2038ebaf&lang=css"

import exportComponent from "/codebuild/output/src383431102/src/serverlesspressoV3/frontends/vue-barista-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__